import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'
import { MAX_CHALLENGES } from '../../constants/settings'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess the word in {MAX_CHALLENGES} tries. 
      </p>
      <br/>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Each guess must be a valid four letter word. Hit the enter button to submit.
      </p>
      <br/>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        After each guess, the color of the tiles will change indicating if the word is higher or lower in the alphabet than your guess.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="A"
          status="lower"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="L"
          status="lower"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="T"
          status="lower"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="O"
          status="lower"
        />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The word is lower in the alphabet than the word ALTO.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="Z"
          status="higher"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="I"
          status="higher"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="N"
          status="higher"
        />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="C"
          status="higher"
        />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The word is higher in the alphabet than the word ZINC.
      </p>

    </BaseModal>
  )
}
